<template>
    <svg class="scroll-indicator" xmlns="http://www.w3.org/2000/svg" width="88" height="88" viewBox="0 0 88 88" @click="$emit( 'click' )">
        <circle cx="44" cy="44" r="44" fill="#fff"/>
        <g transform="translate(26 28)">
            <path d="M1,.6V31.58" transform="translate(17)" fill="none" :stroke="color" stroke-linecap="round" stroke-miterlimit="10" stroke-width="6"/>
            <path d="M0,0,18,16,36,0" transform="translate(0 16)" fill="none" :stroke="color" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="6"/>
        </g>
    </svg>
</template>

<script>
    export default {
        props: {
            color: {
                type: String,
                default: '#a5147e'
            }
        }
    };
</script>

<style>

</style>
